const SELECT_SEARCH_DATA_ROLE = "select.search-empty";

export { SELECT_SEARCH_DATA_ROLE };
//# sourceMappingURL=dataRoles.mjs.map
